/** Mirrors `classNamesFor('InventoryListItem')` — DS utils are not in the public package exports. */
const root = 'Ds-InventoryListItem';

export const inventoryListItemClassNames = {
  root,
  startContent: `${root}-StartContent`,
  label: `${root}-Label`,
  description: `${root}-Description`,
  endContent: `${root}-EndContent`,
};
